import { writable } from 'svelte/store';

export const cognitoUserStore = writable();
